import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { ReportsPageContent } from '@/pageContents/reportsContent/ReportsPageContent';
import { Permission } from '@/models/user';

const ReportsPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Auswertungen | Starjack Backoffice</Helmet>

            <ReportsPageContent />
        </>
    );
};

ReportsPage.isProtected = true;
ReportsPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
ReportsPage.permissions = [Permission.SUPPORTER];

export default ReportsPage;
